<template>
    <!-- Menu -->
    <div class="menu fixed-top " id="menutop">
        <div class="container-fluid fixed-top scrollcolor " id="navbartoggler">
            <nav class="navbar navbar-expand-lg container">
                <a class="navbar-brand mr-0 d-flex  justify-content-center align-items-center " >
                    <img class="img-fluid mobilLogo scroll" src="../img/Recurso 53.png">
                    <!-- <img  class="img-top img-fluid mobilLogo scroll"  src="vistas/dist/custom/imgs/mayos_white.png"> -->
                </a>
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarmenu"
                    aria-controls="navbarmenu" aria-expanded="false" aria-label="Toggle navigation"
                    style="outline: none;">
                    <!-- <div class="barra">
                        <div class="bar1"></div>
                        <div class="bar2"></div>
                        <div class="bar3"></div>
                    </div> -->
                </button>
                <div class="collapse navbar-collapse justify-content-end flex-column align-items-end " id="navbarmenu">
                    <ul class="navbar-nav justify-content-md-start justify-content-start align-items-center widthMenu">


                        <li class="nav-item">
                            <router-link class="button nav-link  btnLog mr-3" >REGISTRO</router-link> 
              
                  
                        </li>
                        <li class="nav-item">
                            <router-link class="button nav-link  btnLog mr-3" >INICIAR SESION</router-link>
                      
                        </li>
                        <li class="nav-item mr-3">

                        </li>
                        <li>
                            <div class="item d-flex"
                                style="border-top: 0px solid transparent;border-bottom: 0px solid transparent;">
                                <a href="https://www.facebook.com/GrupoHorizon/" class="mr-3 itemRed" target="_blank"><i
                                        class="fab fa-facebook iconColor "></i></a>
                                <a href="https://www.instagram.com/grupohorizon.mx/" class="itemRed " target="_blank"><i
                                        class="fab fa-instagram iconColor "></i></a>
                            </div>
                        </li>
                        <li class="nav-item mobilMenu w-100 align-items-start" style="border-top: 1px solid #c2c2c2;">
                            <a class="nav-link mr-2 " href="#"
                                style="font-size: 9px;border-bottom: 0px solid transparent;" target="_blank">CHEVRONCARD
                                2024</a>

                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    </div>

</template>

<script>

export default {
    methods:
    {
        sbLogin() {
            this.$router.push('/login');
        }
    }

}
</script>

<style>
</style>